import api from "./api";

export const getCatalogosByPadre = async (idPadre) => {
    const response = await api.get(
        `/Catalogo/GetCatalogosByIdPadreInLista?idPadre=${idPadre}`
    );

    return response.data.data;
}

export const GetCatalogoById = async (id) => {
    const response = await api.get(
        `/Catalogo/GetCatalogo?id=${id}`
    );

    return response.data.data;
}

// Catalogos padre (IdPadre = 0): alimentan el filtro de la busqueda y el campo
// padre del formulario.
export const getsCatalogoPadre = async () => {
    const response = await api.get("/Catalogo/GetsCatalogoPadre");

    return response.data.data;
}

export const getsCatalogoSearch = async (filters) => {
    const response = await api.get("/Catalogo/GetsCatalogoSearch", { params: filters });

    return response.data.data;
}

export const addUpdateCatalogo = async (catalogo) => {
    const response = await api.post("/Catalogo/AddUpdateCatalogo", catalogo);

    return response.data.data;
}
